import { Image } from "@/components/image";
import { NoImage } from "@/components/no-image/NoImage";
import { Scrim } from "@/components/ui/Scrim";
import { useModalLayer } from "@/contexts/ModalContext";
import * as Dialog from "@radix-ui/react-dialog";
import { CloseButton } from "@/components/ui";

interface ImageModalProps {
  isOpen: boolean;
  onClose: () => void;
  imageUrl?: string;
  alt: string;
  crc?: string;
}

export function ImageModal({ isOpen, onClose, imageUrl, alt, crc }: ImageModalProps) {
  const { zIndex, backdropZIndex } = useModalLayer(isOpen);

  return (
    <Dialog.Root open={isOpen} onOpenChange={onClose}>
      <Dialog.Portal>
        <Dialog.Overlay asChild>
          <Scrim zIndex={backdropZIndex} tone="lightbox" />
        </Dialog.Overlay>
        <Dialog.Content
          aria-describedby={undefined}
          style={{ zIndex }}
          className="fixed inset-0 flex items-center justify-center p-4 focus:outline-none"
        >
          <Dialog.Title className="sr-only">{alt || "Imagem"}</Dialog.Title>
          <Dialog.Close asChild>
            <CloseButton label="Fechar modal" variant="glass" className="absolute top-4 right-4 z-raised-2" />
          </Dialog.Close>

          <div className="relative w-full h-full flex items-center justify-center">
            {imageUrl ? (
              <Image
                src={imageUrl}
                alt={alt}
                width={1024}
                height={1024}
                crc={crc}
                priority
                className="max-w-full max-h-full object-contain rounded-card shadow-overlay"
              />
            ) : (
              <NoImage
                width={500}
                height={500}
                alt={alt}
                className="max-w-full max-h-full object-contain rounded-card shadow-overlay"
              />
            )}
          </div>

          <div
            className="absolute inset-0 z-raised cursor-pointer"
            onClick={onClose}
            aria-label="Fechar modal clicando no fundo"
          />
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
